import { useTheme } from '@mui/material';
import { select } from 'd3-selection';
import { useRef } from 'react';

import { Tooltip } from 'shared/components/charts/BarChart/components/Chart/components/Tooltip';
import { isIntractable } from 'shared/components/charts/BarChart/components/Chart/utils';
import { HEIGHT, FONT_SIZE } from 'shared/components/charts/BarChart/constants';
import { useChartContext } from 'shared/components/charts/BarChart/hooks';
import { useSvgTextTruncate } from 'shared/hooks/dom';

import type { FC } from 'react';
import type { DataPoint } from 'shared/components/charts/BarChart/types';

export const XAxis: FC = () => {
  const { data, xScale, TooltipContent, onInteract } = useChartContext();
  const ref = useRef(null);
  const theme = useTheme();

  useSvgTextTruncate(
    select(ref.current).selectChildren<SVGTextElement, DataPoint>().data(data),
    { maxTextWidth: xScale.step() },
  );

  return (
    <g ref={ref}>
      {data.map(({ id, x, yLabel }, index) => {
        const intractable = isIntractable(yLabel);

        return (
          <Tooltip key={id} title={<TooltipContent x={x} y={data[index].y} />}>
            <text
              x={(xScale(x) ?? 0) + xScale.bandwidth() / 2}
              y={HEIGHT}
              dy="22"
              fill={theme.palette.text.secondary}
              fontSize={FONT_SIZE}
              textAnchor="middle"
              onClick={() => intractable && onInteract(id)}
              cursor={intractable ? 'pointer' : 'initial'}
            >
              {x}
            </text>
          </Tooltip>
        );
      })}
    </g>
  );
};
